import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getJobPositions } from "./Axios";

const PositionsSelect = props => {
  const [positions, setPositions] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "position");
  };

  useEffect(() => {
    getJobPositions((response) => {
      if (response && response.data) {
        const newPositions = response.data.map((position) => ({
          value: position.id,
          label: position.name,
          uniqueIdentifier: position.unique_identifier,
        }));
        setPositions(newPositions);
      }
    });
  }, []);

  return (
    <Select
      inputId="position"
      onChange={handleChange}
      options={positions}
      placeholder="Buscar y seleccionar un cargo"
      value={
        positions.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label} (${e.uniqueIdentifier})`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label, uniqueIdentifier } = option.data;
        return (
          label.toLowerCase().includes(searchTerm) ||
          uniqueIdentifier.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default PositionsSelect;

